const UD_APP_VERSION = "10.4"
const UD_APP_DOWNLOAD_VERSION = "10.4.0"
const UD_APP_DI = "00860461001776"
const UD_APP_BUILD = "104"
export const UDApp = {
  version: UD_APP_VERSION,
  downloadable_version: UD_APP_DOWNLOAD_VERSION,
  about_version: `uDesign Software, FG0064 | Version: ${UD_APP_VERSION}`,
  about_build: `DI: ${UD_APP_DI} | Pl: uDesign ${UD_APP_VERSION} build ${UD_APP_BUILD}`,
  date: `2016 – ${new Date().getFullYear()}  © uLab Systems Inc.`,
  releaseNote: [
    {
      title: "Treatment Planning",
      list: [
        `
    <ol style="list-style-type: decimal; list-style-position: outside; padding-left: 22px; font-size: 14px; color: #00000099 !important;">
       <li style="display: list-item; padding: 0;">
          Added a "–" sign to clearly indicate collisions.
       </li>
       <li style="display: list-item; padding: 0;">
          Fixed the issue where extra space (greater than 0.2) appeared after pre-setup for some cases.
       </li>
       <li style="display: list-item; padding: 0;">
          Made adjustments to ensure proper space alignment.
       </li>
       <li style="display: list-item; padding: 0;">
           Corrected the orientation of the lower jaw on the feature page.
       </li>
    </ol>`,
      ],
    },
    {
      title: "In-Office Printing",
      list: [
        `
    <ol style="list-style-type: decimal; list-style-position: outside; padding-left: 22px; font-size: 14px; color: #00000099 !important;">
       <li style="display: list-item; padding: 0;">
           Enhanced the efficiency of the STL printing process.
       </li>
       <li style="display: list-item; padding: 0;">
           Users can now print without needing to enter Edit mode.
       </li>
    </ol>`,
      ],
    },
    // {
    //   title: "New Features and Tools – Checkout & Ordering",
    //   list: [
    //     `
    // <ol style="list-style-type: decimal; list-style-position: outside; padding-left: 22px; font-size: 14px; color: #00000099 !important;">
    //    <li style="display: list-item; padding: 0;">
    //       All uAssist case submissions and uAssist refinements will be submitted using uDesign Cloud.
    //    </li>
    //    <li style="display: list-item; padding: 0;">
    //       All uSmile orders will be submitted using uDesign Cloud.
    //    </li>
    // </ol>`,
    //   ],
    // },
    // {
    //   title: "Removed Items",
    //   list: [
    //     `
    // <ol style="list-style-type: none; list-style-position: outside; padding-left: 22px; font-size: 14px; color: #00000099 !important;">
    //    <li style="display: list-item; padding: 0;">
    //       The need to select stage for self-planned refinement.
    //    </li>
    // </ol style="list-style-type: decimal; list-style-position: outside; padding-left: 22px; font-size: 14px; color: #00000099 !important;">`,
    //   ],
    // },
    // {
    //   title: "Minor text changes and bug fixes",
    //   list: [
    //     `
    // <ol style="list-style-type: none; list-style-position: outside; padding-left: 22px; font-size: 14px; color: #00000099 !important;">
    //    <li style="display: list-item; padding: 0;">
    //       The ability to add .75 offset on both smooth and semi-scallop trim line.
    //    </li>
    // </ol>`,
    //   ],
    // },
    {
      title: "Additional uDesign 10.2 Updates",
      list: [
        `
    <ol style="list-style-type: decimal; list-style-position: outside; padding-left: 22px; font-size: 14px; color: #00000099 !important;">
       <li style="display: list-item; padding: 0;">
          Minor text changes and bug fixes
       </li>
       <li style="display: list-item; padding: 0;">
          Fixed the issue where demo cases couldn't be opened in uDesign
       </li>
       <li style="display: list-item; padding: 0;">
          Resolved the "Local case file is not complete" error when opening certain cases in uDesign.
       </li>
       <li style="display: list-item; padding: 0;">
          Resolved a crash that occurred when accessing the maxillary label page and closing the case.
       </li>
       <li style="display: list-item; padding: 0;">
          Photos will no longer be re-uploaded unless changes (additions, removals, or updates) are made.
       </li>
       <li style="display: list-item; padding: 0;">
          Ensured that the case remains locked before uploading.
       </li>
    </ol>`,
      ],
    },
    {
      title: "Additional uDesign 10.2.1 Updates",
      list: [
        `
    <ol style="list-style-type: decimal; list-style-position: outside; padding-left: 22px; font-size: 14px; color: #00000099 !important;">
       <li style="display: list-item; padding: 0;">
          Supports computer names longer than 15 characters.
       </li>
       <li style="display: list-item; padding: 0;">
          Includes minor bug fixes related to IDB bracket adjustment.
       </li>
       <li style="display: list-item; padding: 0;">
          The ability to flip a bracket upside down.
       </li>
    </ol>`,
      ],
    },
    {
      title: "Additional uDesign 10.4 Updates",
      list: [
        `
    <ol style="list-style-type: decimal; list-style-position: outside; padding-left: 22px; font-size: 14px; color: #00000099 !important;">
       <li style="display: list-item; padding: 0;">
          Ability to flip a bracket upside down in the IDB function.
       </li>
       <li style="display: list-item; padding: 0;">
          Minor bug fixes.
       </li>
       <li style="display: list-item; padding: 0;">
          Some compatibility issues fixed.
       </li>
    </ol>`,
      ],
    },
  ],
}
